import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';

export class PokerIntegrationService extends ServiceBase {
  constructor(services: IServiceFactoryExtended) {
    super(services);

    this.services.sdk.events.onTokenLifetimeExpired(this._onTokenLifetimeExpired.bind(this));
  }

  private _onTokenLifetimeExpired(): void {
    let externalBrandCallbackInfo = this.services.sdk.getExternalBrandCallbackInfo();
    if(externalBrandCallbackInfo && externalBrandCallbackInfo.url && externalBrandCallbackInfo.method === 'redirect') {
      this.services.location.redirect(externalBrandCallbackInfo.url + '?ActionId=201');
    }
  }
}
